export default "__VITE_ASSET__CWA$BEoD__"